import React from 'react'
import OperadoresMainView from "./OperadoresMainView";

const Operadores = (props) => {
    return (
        <React.Fragment>
            <OperadoresMainView />
        </React.Fragment>
    )
}

export default Operadores;
